import { useEffect } from 'react';

const liveSpinsUrl = 'https://assets.livespins.com/sdk/js/livespins.js';

const useLiveSpins = () => {
    useEffect(() => {
        if (liveSpinsUrl) {
            const script = document.createElement('script');

            script.src = liveSpinsUrl;
            script.async = true;

            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            };
        }
    }, []);
};

export default useLiveSpins;
